export function teamFilter(root = document) {
    const cleanups = [];

    root.querySelectorAll('[data-team-filters]').forEach((filters) => {
        const block = filters.closest('.featured-team');
        const members = [...block.querySelectorAll('[data-team-categories]')];
        const buttons = [...filters.querySelectorAll('[data-team-filter]')];
        const sliderElement = block.querySelector('[data-team-slider]');
        const cards = members.map((member) => member.querySelector('.team-card')).filter(Boolean);
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        const onClick = (event) => {
            const button = event.target.closest('[data-team-filter]');
            if (!button || !filters.contains(button)) return;

            const category = button.dataset.teamFilter;
            buttons.forEach((chip) => {
                const active = chip === button;
                chip.classList.toggle('is-active', active);
                chip.setAttribute('aria-pressed', String(active));
            });
            const visibleMembers = members.filter((member) =>
                category === 'all' || member.dataset.teamCategories.split(' ').includes(category)
            );
            const visibleCards = visibleMembers.map((member) => member.querySelector('.team-card')).filter(Boolean);

            gsap.killTweensOf(cards);
            const updateMembers = () => {
                members.forEach((member) => {
                    member.hidden = !visibleMembers.includes(member);
                    if (member.hidden) {
                        member.querySelectorAll('video').forEach((video) => video.pause());
                    }
                });

                const slider = sliderElement && window.Flickity?.data(sliderElement);
                if (slider) {
                    slider.reloadCells();
                    slider.resize();
                    slider.select(0, false, true);
                }

                if (reducedMotion.matches) {
                    gsap.set(cards, { clearProps: 'opacity,visibility,transform' });
                } else {
                    gsap.set(visibleCards, { autoAlpha: 0, y: 30, scale: 0.98 });
                    gsap.to(visibleCards, {
                        autoAlpha: 1,
                        y: 0,
                        scale: 1,
                        duration: 0.6,
                        stagger: 0.07,
                        ease: 'power4.out',
                        clearProps: 'opacity,visibility,transform',
                    });
                }
                window.ScrollTrigger?.refresh();
            };

            if (reducedMotion.matches) {
                updateMembers();
            } else {
                gsap.to(members.filter((member) => !member.hidden).map((member) => member.querySelector('.team-card')).filter(Boolean), {
                    autoAlpha: 0,
                    y: 20,
                    scale: 0.98,
                    duration: 0.25,
                    ease: 'power2.out',
                    stagger: 0.02,
                    onComplete: updateMembers,
                });
            }
        };

        filters.addEventListener('click', onClick);
        cleanups.push(() => {
            filters.removeEventListener('click', onClick);
            gsap.killTweensOf(cards);
        });
    });

    return () => cleanups.forEach((cleanup) => cleanup());
}
